import type { HelpCenterLogCorrelation } from '@zep-us/cs';
import { crmUserContext } from '@zep-us/cs/user-context';
import { createHelpCenterUserInfo } from '@zep-us/cs/user-info';

import { type UserInfo } from '@/types';
import { getApplicationSessionId } from '@/utils/common/getApplicationSessionId';
import { getBrowserSessionId } from '@/utils/common/getBrowserSessionId';
import { getDeviceId } from '@/utils/common/getDeviceId';

/** QuizAppLoggerInitializer 가 로그에 싣는 것과 같은 getter 를 써야 ClickHouse 조회 값이 맞는다. */
export function getQuizHelpCenterLogCorrelation(): HelpCenterLogCorrelation {
  return {
    deviceId: getDeviceId(),
    browserSessionId: getBrowserSessionId(),
    applicationSessionId: getApplicationSessionId(),
  };
}

export function toQuizHelpCenterUserInfo(user: UserInfo | null | undefined) {
  return createHelpCenterUserInfo(user, user => ({
    id: user.quizUserId,
    email: user.email,
    name: user.username,
    context: {
      ...crmUserContext({
        country_code: user.countryCode,
        user_type: user.type,
        plan_type: user.planType,
        is_paid_user: user.planType !== 'FREE',
      }),
      plan_status: user.planStatus,
      plan_started_at: user.planDuration?.startDate,
      plan_expires_at: user.planDuration?.endDate,
      quiz_user_id: user.quizUserId,
      is_ambassador: user.isAmbassador,
      is_admin: user.admin,
      workspace_id: user.workspace?.workspaceHashId,
      workspace_name: user.workspace?.workspaceName,
      is_paid_workspace_owner: user.workspace?.isPaidOwner,
      teacher_school_type_code: user.teacherSchoolInfo?.schoolTypeCode,
      teacher_school_grade_code: user.teacherSchoolInfo?.schoolGradeCode,
      recent_quiz_created_at: user.recentQuizsetInfo?.createdAt,
      recent_quiz_school_type: user.recentQuizsetInfo?.schoolType,
      recent_quiz_school_grade: user.recentQuizsetInfo?.schoolGrade,
      recent_quiz_school_semester: user.recentQuizsetInfo?.schoolSemester,
    },
  }));
}
